import {
  isSimpleSelection,
  hasFrameBehaviors,
  isMindMapBranch,
} from '../objects/guards';
import Tool, { type IToolActionInput } from './Tool';

class ToolExportSelectionPNG extends Tool {
  static toolName = 'Export selection to PNG';

  static action({ controller, selection }: IToolActionInput) {
    const canvas = controller.canvas;

    // Collect all objects that should be included in the export
    const objectsToInclude: fabric.Object[] = [];

    const checkFrameContainmentRecursive = (
      selectedObj: fabric.Object,
      obj: fabric.Object
    ): boolean => {
      if (hasFrameBehaviors(selectedObj) && selectedObj.children.length > 0) {
        // Check direct children
        if (selectedObj.children.includes(obj)) {
          return true;
        }
        // Recursively check nested frames
        return selectedObj.children.some(
          child =>
            hasFrameBehaviors(child) &&
            checkFrameContainmentRecursive(child, obj)
        );
      }
      return false;
    };

    // Find all objects that should be included in both filter and bounding rect
    canvas.getObjects().forEach(obj => {
      let shouldInclude = false;

      if (isMindMapBranch(obj)) return;

      if (isSimpleSelection(selection)) {
        shouldInclude = selection.objectInSelection(obj);
      } else {
        shouldInclude = obj === selection;
      }

      // If not directly in selection, check if it's inside a selected frame (recursively)
      if (!shouldInclude) {
        if (isSimpleSelection(selection)) {
          // Check all selected objects for frames
          shouldInclude = selection._objects.some(selectedObj =>
            checkFrameContainmentRecursive(selectedObj, obj)
          );
        } else {
          // Check single selection
          shouldInclude = checkFrameContainmentRecursive(selection, obj);
        }
      }

      if (shouldInclude) {
        objectsToInclude.push(obj);
      }
    });

    // Calculate bounding rect that includes all objects that will be exported
    const usedRect = canvas.rectContainingObjects(objectsToInclude);

    const filter = (obj: fabric.Object) => {
      return objectsToInclude.includes(obj);
    };

    const result = canvas.renderToPng(usedRect, { filter });

    if (!result.success) {
      controller.actionShowMessage({ message: result.error, type: 'error' });
      return;
    }

    // Create a fake link to trigger the download.
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.target = '_blank';

    a.href = result.dataUrl;

    a.download = `${controller.exportFileName}.png`;
    a.click();
    a.remove();
  }
}

export default ToolExportSelectionPNG;
